export const contentTypes = {
    multipart: {
      'Content-Type': 'multipart/form-data'
    },
    json: {
      'Content-Type': 'application/json'
    }
  };